export default "__VITE_ASSET__CoyzUzbo__"